window.addEventListener("load", () => {
    let scrolled = false;
    if (window.location.hash && !scrolled) {
        const hash = window.location.hash.substring(1);
        function isElementInView(el) {
            let rect = el.getBoundingClientRect();
            return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
        }

        setTimeout(function () {
            const element = document.getElementById(hash);
            if (element && !isElementInView(element)) {
                scrolled = true;
                element.scrollIntoView({ behavior: "smooth" });
            }
        }, 500);
    }
});